var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title",staticStyle:{"background":"#f8f9fa"}},[_c('span',{staticClass:"header-title-text ml-3"},[_vm._v("จัดการสิทธิ์ตามเครือและบริษัท")])])
}]

export { render, staticRenderFns }